// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag-module__tag___1a-w3","tagActive":"Tag-module__tagActive___3e0Sp","tagClose":"Tag-module__tagClose___1dgL2"};